import { escape } from 'lodash'

export function patternToHtml(templateField, handsOnTable, rowNum) {
  const pattern = []
  const isEmptyRow = handsOnTable.isEmptyRow(rowNum)
  templateField.field.segments.forEach(mergeWithPattern)
  const patternInner = pattern.join(templateField.field.delimiter)
  const visibilityCls = isEmptyRow ? 'visible-on-active' : ''
  return `<div class="${visibilityCls}">${patternInner}</div>`

  function mergeWithPattern(segment) {
    let patternSegment = null
    let cellResult = null
    switch (segment.segment_type) {
      case 'autonumber':
        patternSegment = `<span class="htPatternPlaceholder">[Auto Number]</span>`
        break
      case 'constant':
        patternSegment = escape(segment.constant_value)
        break
      case 'date':
        if (segment.date.auto_populate) {
          patternSegment = `<span class="htPatternPlaceholder">[Submission Date]</span>`
        } else {
          cellResult = getCellValueOnRowByFieldWithHOT(handsOnTable, segment.id, rowNum)
          patternSegment = wrapWithMissingWarningIfNeeded(cellResult)
        }
        break
      case 'random':
        patternSegment = `<span class="htPatternPlaceholder">[Random]</span>`
        break
      case 'variable':
        cellResult = getCellValueOnRowByFieldWithHOT(handsOnTable, segment.id, rowNum)
        patternSegment = wrapWithMissingWarningIfNeeded(cellResult)
        break
    }
    pattern.push(patternSegment)
  }
}

function wrapWithMissingWarningIfNeeded(cellResult) {
  if (!cellResult) {
    return ''
  }

  // if not missing, just return the value
  if (!cellResult.isMissing) {
    return escape(cellResult.value)
  }

  // wrap missing values with warning and popoover
  return `<span class="htPatternMissingSegment">
        ${escape(cellResult.value)}
        <div class="tooltipWrapper">
            <div class="validationTooltip arrow-top">
                <h3>Why am I seeing this?</h3>
                <p >
                    A <span class="text-danger" style="font-family: monospace">[MISSING COLUMN]</span> warning normally indicates a misconfigured Submission Template.
                    This can happen if Pattern Variables were added or removed without updating the corresponding Submission Template.
                </p>
                <p style="font-weight: 600;">Please let your administrator know that this Submission Template may need to be updated.</p>
            </div>
        </div>
    </span>`
}
function getCellValueOnRowByFieldWithHOT(handsOnTable, field_id, rowNum) {
  const settings = handsOnTable.getSettings()
  const { allColumnsByFieldId } = settings
  // little worried by this.
  if (!allColumnsByFieldId) {
    return
  }
  const column = allColumnsByFieldId[field_id]

  if (!column) {
    // something is wrong with the template... a patten part is missing...
    // warn and fill with "missing" so we know something needs to be fixed.
    console.warn(`[CLARAVINE] missing column for field ${field_id}`)
    return {
      isMissing: true,
      value: '[MISSING COLUMN]',
    }
  }

  const variableCellValue = handsOnTable.getDataAtRowProp(rowNum, `${column.field_id}.cell_value`)
  return { value: variableCellValue }
}
